// extracted by mini-css-extract-plugin
module.exports = {"myPickText":"TheClosedAndLiveSummerMatch_myPickText_3vI1b","athleteName":"TheClosedAndLiveSummerMatch_athleteName_1qsfm"};